<template>

</template>

<script>
export default {
    name: "CompetitionFilterNoneLayout"
}
</script>

<style scoped>

</style>